/**
 * Given a sentence in the format:
 * "The [quick] brown fox jumps [over] the lazy dog."
 *
 * Split this sentence in parts and return an array of objects with the following structure:
 *
 * [
 *   {text: "The ", highlight: false },
 *   {text: "quick", highlight: true },
 *   ...
 * ]
 *
 * @param sentenceStr
 */
export function parseSentenceWithHighlights(sentenceStr) {
    const result = [];
    let currentText = "";
    let highlight = false;

    for (let i = 0; i < sentenceStr.length; i++) {
        const char = sentenceStr[i];

        if (char === '[') {
            if (currentText) {
                result.push({ text: currentText, highlight: highlight });
                currentText = "";
            }
            highlight = true;
        } else if (char === ']') {
            if (currentText) {
                result.push({ text: currentText, highlight: highlight });
                currentText = "";
            }
            highlight = false;
        } else {
            currentText += char;
        }
    }

    if (currentText) {
        result.push({ text: currentText, highlight: highlight });
    }

    return result;
}